import React from 'react';

const App = ({ children }) => (
  <div className="App">
    {children}
  </div>
);

export default App;
